import React from 'react';
import { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';
//import './styles/css2.css';
import './styles/css1.css';
import './styles/media_upload.css';
import './styles/upload.css';
import { withRouter } from 'react-router'


var devices = ''
//var device = ''
var dragged_filename = ''
var dragged_image = ''
var current_output_filename = ''

//window.setInterval(update_current_output(), 10000);


export default class image_upload extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      sn: '',
      m_18_24: '',
      m_25_34: '',
      m_35_44: '',
      m_45_54: '',
      m_55_64: '',
      m_65: '',
      f_18_24: '',
      f_25_34: '',
      f_35_44: '',
      f_45_54: '',
      f_55_64: '',
      f_65: '',
      device: '',
      devices: '',
      upload_filename: '',
      b64_img_output: ''
      };

    this.update_sn = this.update_sn.bind(this);
    this.update_fields = this.update_fields.bind(this);
    this.drop = this.drop.bind(this);
    this.upload = this.upload.bind(this);
    this.update_db = this.update_db.bind(this);
    this.update_current_output = this.update_current_output.bind(this);
  }

  readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}


    componentDidMount() {

    this.timerID = setInterval(() => {
       this.update_current_output()
    }, 60000);

        var ele_img_current_output = document.getElementById('current_output_img');
        ele_img_current_output.addEventListener('dragover', (event) => {
           event.preventDefault();
//           console.log('dragover')
        });
        ele_img_current_output.addEventListener('drop', (event) =>{
        if(dragged_image !== ''){
			event.preventDefault()
//			console.log('drop')
//			console.log(dragged_filename)
//			console.log(dragged_image)
			ele_img_current_output.src = dragged_image
			var ele_lbl_output = document.getElementById('lbl_output');
			ele_lbl_output.innerHTML = 'Live Output - ' + dragged_filename
			this.update_db(dragged_filename, 'output')
			dragged_image = ''
			dragged_filename = ''
			//this.event.unbind('drop')
			}
        });


        var ele_img_m_18_24 = document.getElementById('img_m_18_24');
        ele_img_m_18_24.addEventListener('dragover', (event) => {
           event.preventDefault();
//           console.log('dragover')
        });
        ele_img_m_18_24.addEventListener('drop', (event) =>{
        if(dragged_image !== ''){
			event.preventDefault()
//			console.log('drop')
//			console.log(dragged_filename)
//			console.log(dragged_image)
			ele_img_m_18_24.src = dragged_image
			var ele_lbl_m_18_24 = document.getElementById('lbl_m_18_24');
			ele_lbl_m_18_24.innerHTML = dragged_filename
			this.update_db(dragged_filename, '18_24_m')
			dragged_image = ''
			dragged_filename = ''
			//this.event.unbind('drop')
			}
        });

        var ele_img_m_25_34 = document.getElementById('img_m_25_34');
        ele_img_m_25_34.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_m_25_34.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_m_25_34.src = dragged_image
				var ele_lbl_25_34_m = document.getElementById('lbl_25_34_m');
				ele_lbl_25_34_m.innerHTML = dragged_filename
				this.update_db(dragged_filename, '25_34_m')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_m_35_44 = document.getElementById('img_m_35_44');
        ele_img_m_35_44.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_m_35_44.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_m_35_44.src = dragged_image
				var ele_lbl_35_44_m = document.getElementById('lbl_35_44_m');
				ele_lbl_35_44_m.innerHTML = dragged_filename
				this.update_db(dragged_filename, '35_44_m')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_m_45_54 = document.getElementById('img_m_45_54');
        ele_img_m_45_54.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_m_45_54.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_m_45_54.src = dragged_image
				var ele_lbl_45_54_m = document.getElementById('lbl_45_54_m');
				ele_lbl_45_54_m.innerHTML = dragged_filename
				this.update_db(dragged_filename, '45_54_m')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_m_55_64 = document.getElementById('img_m_55_64');
        ele_img_m_55_64.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_m_55_64.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_m_55_64.src = dragged_image
				var ele_lbl_55_64_m = document.getElementById('lbl_55_64_m');
				ele_lbl_55_64_m.innerHTML = dragged_filename
				this.update_db(dragged_filename, '55_64_m')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_m_65 = document.getElementById('img_m_65');
        ele_img_m_65.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_m_65.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_m_65.src = dragged_image
				var ele_lbl_65_m = document.getElementById('lbl_65_m');
				ele_lbl_65_m.innerHTML = dragged_filename
				this.update_db(dragged_filename, '65_m')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_f_18_24 = document.getElementById('img_f_18_24');
        ele_img_f_18_24.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_f_18_24.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_f_18_24.src = dragged_image
				var ele_lbl_18_24_f = document.getElementById('lbl_18_24_f');
				ele_lbl_18_24_f.innerHTML = dragged_filename
				this.update_db(dragged_filename, '18_24_f')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_f_25_34 = document.getElementById('img_f_25_34');
        ele_img_f_25_34.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_f_25_34.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_f_25_34.src = dragged_image
				var ele_lbl_25_34_f = document.getElementById('lbl_25_34_f');
				ele_lbl_25_34_f.innerHTML = dragged_filename
				this.update_db(dragged_filename, '25_34_f')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_f_35_44 = document.getElementById('img_f_35_44');
        ele_img_f_35_44.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
			ele_img_f_35_44.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_f_35_44.src = dragged_image
				var ele_lbl_35_44_f = document.getElementById('lbl_35_44_f');
				ele_lbl_35_44_f.innerHTML = dragged_filename
				this.update_db(dragged_filename, '35_44_f')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_f_45_54 = document.getElementById('img_f_45_54');
        ele_img_f_45_54.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_f_45_54.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_f_45_54.src = dragged_image
				var ele_lbl_45_54_f = document.getElementById('lbl_45_54_f');
				ele_lbl_45_54_f.innerHTML = dragged_filename
				this.update_db(dragged_filename, '45_54_f')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_f_55_64 = document.getElementById('img_f_55_64');
        ele_img_f_55_64.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_f_55_64.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_f_55_64.src = dragged_image
				var ele_lbl_55_64_f = document.getElementById('lbl_55_64_f');
				ele_lbl_55_64_f.innerHTML = dragged_filename
				this.update_db(dragged_filename, '55_64_f')
				dragged_image = ''
				dragged_filename = ''
				}
        });

        var ele_img_f_65 = document.getElementById('img_f_65');
        ele_img_f_65.addEventListener('dragover', (event) => {
           event.preventDefault();
        });
        ele_img_f_65.addEventListener('drop', (event) =>{
			if(dragged_image !== ''){
				event.preventDefault()
				ele_img_f_65.src = dragged_image
				var ele_lbl_65_f = document.getElementById('lbl_65_f');
				ele_lbl_65_f.innerHTML = dragged_filename
				this.update_db(dragged_filename, '65_f')
				dragged_image = ''
				dragged_filename = ''
				}
        });


       try {
	       var xhr1 = new XMLHttpRequest()
		   xhr1.addEventListener('load', () => {
		   this.data = JSON.parse(xhr1.responseText);//parse response text into data object
		   //console.log("response from server: " + this.data.result);
		   //console.log("sn: " + this.data.sn[0]);
		   this.setState({ sn: this.data.sn[0]});
		   this.state.devices = this.data.sn
		   devices = this.data.sn
		   this.state.device = this.state.devices[0]
		   this.state.sn = this.state.devices[0]
		   this.setState({ sn: this.state.devices[0]});
		   this.setState({ locations: this.data.location_desc});
		   //console.log('locations:' + this.data.location_desc)
		   var select_item = document.getElementById("device_selector")
		   var option = document.createElement("option")
				 try{
					 for(var i=0;i<this.data.sn.length;i++){
						 option = document.createElement("option")
						 option.text = this.data.sn[i] + ' --- ' + this.data.location_desc[i]
						 option.value = this.data.sn[i]
						 select_item.add(option)

						 }
				 }catch(error){
					 console.log(error)
				 }

				 this.update_fields();

				})
			xhr1.open('POST', 'http://3.21.222.196:3035/get_devices');//87 is considered unsafe by Chrome
			xhr1.setRequestHeader("Content-Type", "application/json");
			xhr1.send(JSON.stringify({'email': this.readCookie('email')}));
       }catch(error){
              window.globalPath = 'image_upload'
			  this.props.history.push({
			  pathname: '/login'
			  })
       }






     //console.log(this.props.location.state.email)
     try {
     //console.log(window.globalEmail)
     //console.log(window.globalPassword)
     //console.log(window.globalFirstName)
     //console.log(window.globalLastName)
     this.setState.email = window.globalEmail;
     this.setState.first_name = window.globalFirstName;
     this.setState.last_name = window.globalLastName;

//     console.log(this.props.location.state.email)
//     console.log(this.props.location.state.password)
//     console.log(this.props.location.state.first_name)
//     console.log(this.props.location.state.last_name)
     if (typeof window.globalEmail === 'undefined'){
          window.globalPath = 'image_upload'
          this.props.history.push({
          pathname: '/login'
          })
     }else{
//          document.getElementById('email_address').value = window.globalEmail;
//          this.setState.email = window.globalEmail;
//          document.getElementById('first_name').value = window.globalFirstName;
//          this.setState.first_name = window.globalFirstName;
//          document.getElementById('last_name').value = window.globalLastName;
//          this.setState.last_name = window.globalLastName;

     }


     //document.getElementById('email_address').value = this.props.location.state.email;

     //document.getElementById('password').value = this.props.location.state.password
     } catch (e) {
          console.log('Error getting state - go to login')

          }


  }//end of componentDidMount

  componentWillUnmount() {
     clearInterval(this.timerID);
  }

//   drop_18_24_div = (event) => {
//     event.preventDefault();
//     console.log('drop_18_24_div')
//  }

update_current_output() {
   //alert('update current output')
   var select_item = document.getElementById("device_selector")
   var xhr5 = new XMLHttpRequest()
   xhr5.addEventListener('load', () => {
   //this.data = xhr2.response
   this.data = JSON.parse(xhr5.responseText);//parse response text into data object
   //console.log("response from server: " + this.data.img_35_44);
   console.log(this.data);
   if(this.data.message == 'update'){
	   this.setState({ b64_img_output: this.data.current_output_img});
	   var img_output = document.getElementById('current_output_img');
	   img_output.src = 'data:image/jpg;base64,' + this.state.b64_img_output;
	   var lbl_output = document.getElementById('lbl_output');
	   lbl_output.innerHTML = 'Live Output - ' + this.data.output_filename
	   current_output_filename = this.data.output_filename
   }



	});

	xhr5.open('POST', 'http://3.21.222.196:5090/get_current_output');//87 is considered unsafe by Chrome
	xhr5.setRequestHeader("Content-Type", "application/json, application/blob");
	//console.log("device: " + devices[select_item.selectedIndex]);
	xhr5.send(JSON.stringify({'serial_number': devices[select_item.selectedIndex].toString(), 'current_output_filename': current_output_filename}));


}

update_db(dragged_filename, demographic){
    console.log(dragged_filename, demographic)
    var select_item = document.getElementById("device_selector")
        var xhr4 = new XMLHttpRequest()
           xhr4.addEventListener('load', () => {
			   this.data = JSON.parse(xhr4.responseText);
			   console.log(this.data);
			   //alert(this.data.message)

           })
        xhr4.open('POST', 'http://3.21.222.196:5090/update_db');//87 is considered unsafe by Chrome
        xhr4.setRequestHeader("Content-Type", "application/json, application/blob");
        //console.log("device: " + devices[select_item.selectedIndex]);
        xhr4.send(JSON.stringify({'serial_number': devices[select_item.selectedIndex].toString(), 'dragged_filename': dragged_filename, 'demographic': demographic}));


}

  update_fields(){
      try{
           var select_item = document.getElementById("device_selector")
           this.setState({ sn: select_item.value});
           this.setState({ device: select_item.value});
           //console.log(select_item.selectedIndex);
           //console.log(select_item.value);
           var xhr2 = new XMLHttpRequest()
           xhr2.addEventListener('load', () => {
           //this.data = xhr2.response
           this.data = JSON.parse(xhr2.responseText);//parse response text into data object
           //console.log("response from server: " + this.data.img_35_44);
           console.log(this.data.message);
           if(this.data.message=='error'){
               alert('Error retrieving media')
           }



           this.setState({ b64_img_output: this.data.b64_img_output});
		   var img_output = document.getElementById('current_output_img');
		   img_output.src = 'data:image/jpg;base64,' + this.state.b64_img_output;
		   var lbl_output = document.getElementById('lbl_output');
		   lbl_output.innerHTML = 'Live Output - ' + this.data.output_filename
		   current_output_filename = this.data.output_filename


           this.setState({ m_18_24: this.data.img_m_18_24});
		   var img_m_18_24 = document.getElementById('img_m_18_24');
		   img_m_18_24.src = 'data:image/jpg;base64,' + this.state.m_18_24;
		   var lbl_m_18_24 = document.getElementById('lbl_m_18_24');
		   lbl_m_18_24.innerHTML = this.data.m_18_24_filename


		   this.setState({ m_25_34: this.data.img_m_25_34});
		   var img_m_25_34 = document.getElementById('img_m_25_34');
		   img_m_25_34.src = 'data:image/jpg;base64,' + this.state.m_25_34;
		   var lbl_m_25_34 = document.getElementById('lbl_25_34_m');
		   lbl_m_25_34.innerHTML = this.data.m_25_34_filename

		   this.setState({ m_35_44: this.data.img_m_35_44});
		   var img_m_35_44 = document.getElementById('img_m_35_44');
		   img_m_35_44.src = 'data:image/jpg;base64,' + this.state.m_35_44;
		   var lbl_m_35_44 = document.getElementById('lbl_35_44_m');
		   lbl_m_35_44.innerHTML = this.data.m_35_44_filename

		   this.setState({ m_45_54: this.data.img_m_45_54});
		   var img_m_45_54 = document.getElementById('img_m_45_54');
		   img_m_45_54.src = 'data:image/jpg;base64,' + this.state.m_45_54;
		   var lbl_m_45_54 = document.getElementById('lbl_45_54_m');
		   lbl_m_45_54.innerHTML = this.data.m_45_54_filename

		   this.setState({ m_55_64: this.data.img_m_55_64});
		   var img_m_55_64 = document.getElementById('img_m_55_64');
		   img_m_55_64.src = 'data:image/jpg;base64,' + this.state.m_55_64;
		   var lbl_m_55_64 = document.getElementById('lbl_55_64_m');
		   lbl_m_55_64.innerHTML = this.data.m_55_64_filename

		   this.setState({ m_65: this.data.img_m_65});
		   var img_m_65 = document.getElementById('img_m_65');
		   img_m_65.src = 'data:image/jpg;base64,' + this.state.m_65;
		   var lbl_m_65 = document.getElementById('lbl_65_m');
		   lbl_m_65.innerHTML = this.data.m_65_filename

		   this.setState({ f_18_24: this.data.img_f_18_24});
		   var img_f_18_24 = document.getElementById('img_f_18_24');
		   img_f_18_24.src = 'data:image/jpg;base64,' + this.state.f_18_24;
		   var lbl_f_18_24 = document.getElementById('lbl_18_24_f');
		   lbl_f_18_24.innerHTML = this.data.f_18_24_filename

		   this.setState({ f_25_34: this.data.img_f_25_34});
		   var img_f_25_34 = document.getElementById('img_f_25_34');
		   img_f_25_34.src = 'data:image/jpg;base64,' + this.state.f_25_34;
		   var lbl_f_25_34 = document.getElementById('lbl_25_34_f');
		   lbl_f_25_34.innerHTML = this.data.f_25_34_filename

		   this.setState({ f_35_44: this.data.img_f_35_44});
		   var img_f_35_44 = document.getElementById('img_f_35_44');
		   img_f_35_44.src = 'data:image/jpg;base64,' + this.state.f_35_44;
		   var lbl_f_35_44 = document.getElementById('lbl_35_44_f');
		   lbl_f_35_44.innerHTML = this.data.f_35_44_filename

		   this.setState({ f_45_54: this.data.img_f_45_54});
		   var img_f_45_54 = document.getElementById('img_f_45_54');
		   img_f_45_54.src = 'data:image/jpg;base64,' + this.state.f_45_54;
		   var lbl_f_45_54 = document.getElementById('lbl_45_54_f');
		   lbl_f_45_54.innerHTML = this.data.f_45_54_filename

		   this.setState({ f_55_64: this.data.img_f_55_64});
		   var img_f_55_64 = document.getElementById('img_f_55_64');
		   img_f_55_64.src = 'data:image/jpg;base64,' + this.state.f_55_64;
		   var lbl_f_55_64 = document.getElementById('lbl_55_64_f');
		   lbl_f_55_64.innerHTML = this.data.f_55_64_filename

		   this.setState({ f_65: this.data.img_f_65});
		   var img_f_65 = document.getElementById('img_f_65');
		   img_f_65.src = 'data:image/jpg;base64,' + this.state.f_65;
		   var lbl_f_65 = document.getElementById('lbl_65_f');
		   lbl_f_65.innerHTML = this.data.f_65_filename

//           console.log(this.data)

           try {
               var lib_div = document.getElementById('lib_div')
			   while (lib_div.firstChild) {
				   lib_div.removeChild(lib_div.firstChild)
			   }

           }catch(error){

           }

       //populate media library
           for (let i = 0; i < this.data.num_filenames; i++) {
               var lib_img = document.createElement('img');
               lib_img.src = 'data:image/jpg;base64,' + Object.values(this.data.lib_imgs)[i]
               lib_img.className = 'img_size'
               lib_img.draggable = "true"
               lib_img.style.cursor = 'grab'
               lib_img.id = "img" + i.toString()
               lib_img.addEventListener('dragstart', (e) => {
                    var lib_img_data = document.getElementById(i)
                    //console.log(test.innerHTML)
                    //this.setState({dragged_filename: test.innerHTML.toString()});
                    dragged_filename = lib_img_data.innerHTML
                    //dragged_image = lib_img_data.src
               })

               lib_img.addEventListener('dragstart', (e) => {
                    var lib_img_data = document.getElementById("img" + i.toString())
                    //console.log(test.innerHTML)
                    dragged_image = lib_img_data.src
               })
//               lib_img.addEventListener('drop', (e) => {
//                    //var test = document.getElementById(i)
//                    console.log('dropped')
//                    //this.setState({dragged_filename: test.innerHTML.toString()});
//                    //dragged_filename = test.innerHTML
//               })
               document.getElementById('lib_div').appendChild(lib_img)
               var lib_lbl = document.createElement('div');
               lib_lbl.innerHTML = Object.values(this.data.file_names)[i]
               lib_lbl.id = i.toString()
               document.getElementById('lib_div').appendChild(lib_lbl)
               lib_lbl.className = 'lib_lbl'
           }
                })



        xhr2.open('POST', 'http://3.21.222.196:5090/get_image_filenames');//87 is considered unsafe by Chrome
        xhr2.setRequestHeader("Content-Type", "application/json, application/blob");
        //console.log("device: " + devices[select_item.selectedIndex]);
        xhr2.send(JSON.stringify({'serial_number': devices[select_item.selectedIndex].toString()}));

       }catch(error){
              this.props.history.push({
               //pathname: '/modify_device_settings'
              })

       }
  }



  update_sn(event) {
    this.setState({ sn: event.target.value });
    //console.log(this.state.sn);
  }

//  update_location(event) {
//    this.setState({ location: event.target.value });
//    //console.log(this.state.location);
//  }
//


  drop = (event) => {
  event.preventDefault();
  var drop_zone = document.getElementById('drop_zone');
  drop_zone.classList.add('hidden');
  var preview_zone = document.getElementById('preview_zone');
  preview_zone.classList.add('visible');
  preview_zone.classList.remove('hidden');
  let dt = event.dataTransfer
  let files = dt.files
  console.log(files)
  console.log(files[0].name)
   this.setState({ upload_filename: files[0].name});
  let reader = new FileReader()
  reader.readAsDataURL(files[0])
  console.log(reader)
  reader.onloadend = function() {
   let img = document.createElement('img')
   img.id = 'img'
   img.src = reader.result
    img.style.width = '205px';
    img.style.height= '115px';
   document.getElementById('preview_zone').appendChild(img)
  }
  console.log(reader)
}

  upload = (event) => {
		var img = document.getElementById('img')

		var image = img.src
		//console.log(image.toString('base64'))
		var select_item = document.getElementById("device_selector")
		var xhr3 = new XMLHttpRequest()
			   xhr3.addEventListener('load', () => {
			   //this.data = xhr3.response
			   this.data = JSON.parse(xhr3.responseText);
			   console.log(this.data);
			   //alert(this.data.message)
			   this.update_fields();

			})
			xhr3.open('POST', 'http://3.21.222.196:5090/upload_file');//87 is considered unsafe by Chrome
			xhr3.setRequestHeader("Content-Type", "application/json, application/blob");
			//console.log("device: " + devices[select_item.selectedIndex]);
			xhr3.send(JSON.stringify({'serial_number': devices[select_item.selectedIndex].toString(), 'img': image.toString('base64'), 'filename': this.state.upload_filename}));

		event.preventDefault();
		var drop_zone = document.getElementById('drop_zone');
		drop_zone.classList.add('visible');
		drop_zone.classList.remove('hidden');
		var preview_zone = document.getElementById('preview_zone');
		preview_zone.classList.add('hidden');
		preview_zone.classList.remove('visible');
		while (preview_zone.firstChild) {
			preview_zone.removeChild(preview_zone.firstChild);
		}
}



  render() {

    return (
      <div className='container'>
        <div className="container3">
        <div className="header">
          <div className="menu1">
            <NavLink to="/" activeClassName="is-active" exact={true}>Home</NavLink>
          </div>
          <div className="menu2"><a href="/#setup">Setup</a></div>
          <div className="menu3"><NavLink to="/register" activeClassName="is-active" exact={true}>Register Your Device</NavLink></div>
          <div className="menu5"><NavLink to="/reporting_dashboard" activeClassName="is-active" exact={true}>Reports</NavLink></div>
          <div className="menu4"><NavLink to="/login" activeClassName="is-active" exact={true}>Login</NavLink></div>
        </div>
        <div className="row">
          <center>
            <div className="col-12 col-s-12">

              <div className="col-12 col-s-12">
                <img className="center_img2" src="argon_one_case2D_black_custom_blue.png" alt="" />
			<div className="container_header">
			    <div id="left_container_header">
			        <div id="current_output"><img id='current_output_img'></img>
			        </div>
			        <div className="tooltip_div">
				    <div className="tooltip2"><img className="center_img4" src="tooltip_icon.png" alt="" /><span id='lbl_output' className='lbl_live_output'>Live Output&nbsp;</span>
                        <span className="tooltip2text">The current media displayed on the screen, updated here every 60 seconds.</span></div>
                    </div>
			    </div>

				<div id="center_container_header">
                <p className="text_catch2">Smart Digital Signage Media Configuration</p>

			<div className="container_upload">

				<div id="center_container_upload" className="center_container_upload">
				    <div className="tooltip"><img className="center_img3" src="tooltip_icon.png" alt="" />Serial Number:&nbsp;
                        <span className="tooltiptext">Your serial number is found on the bottom of the device</span></div>
				<select id="device_selector" name="device" size="1" onChange={this.update_fields}></select>
				</div>
				<div id="right_container_upload" className="right_container_upload">
				</div>


			</div>
				</div>
				<div id="right_container_header">
		            <i className="glyphicon glyphicon-download-alt"></i><section>
						<div className="container_upload2">
							  <div className="row">
								<div className="drop_zone_container">
								  <div className="form-group">
									<label className="control-label hidden">Upload File</label>
									  <div className="dropzone-wrapper" id="drop_zone" onDrop={this.drop}>
										 <div className="dropzone-desc">
										   <i className="glyphicon glyphicon-download-alt"></i>

										   <p>Click and choose an image file or drag it here.</p>
										   <p>Image must be a .jpg<br></br>1920px x 1080px</p>
										 </div>
										 <input type="file" name="img_logo" className="dropzone"></input>
									  </div>
									  <div id='preview_zone' className="preview-zone hidden">
									  <div className="box box-solid">
										<div className="box-header">
										  <div><b>Preview</b></div>
										  <div className="box-tools pull-right">
										  </div>
										</div>
										<div className="box-body"></div>
									   </div>
									</div>
								  </div>
							  </div>
							</div>
						</div>
							  <div className="row">
								<div className="upload_btn_container">
								  <button className="upload_btn" onClick={this.upload}>Upload to Media Library</button>
								</div>
							  </div>
						</section>
						<div className="preview-zone ">

						</div>
				</div>
			</div>

			<div className="container">
				<div id="left_container">
					<div id="top_row">
					    <div className="top-row-div_header">Male 18-24</div>
						<div className="top-row-div_header">Male 25-34</div>
						<div className="top-row-div_header">Male 35-44</div>
						<div className="top-row-div_header">Male 45-54</div>
						<div className="top-row-div_header">Male 55-64</div>
						<div className="top-row-div_header">Male 65+</div>
					</div>
					<div id="top_row">
						<div className="top-row-div"><img id='img_m_18_24' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_m_25_34' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_m_35_44' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_m_45_54' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_m_55_64' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_m_65' className='img_size'></img></div>
					</div>
					<div id="top_row">
					    <div className="top-row-div_label" id='lbl_m_18_24'></div>
						<div className="top-row-div_label" id='lbl_25_34_m'></div>
						<div className="top-row-div_label" id='lbl_35_44_m'></div>
						<div className="top-row-div_label" id='lbl_45_54_m'></div>
						<div className="top-row-div_label" id='lbl_55_64_m'></div>
						<div className="top-row-div_label" id='lbl_65_m'></div>
					</div>
					<div id="top_row">
					    <div className="top-row-div_header">Female 18-24</div>
						<div className="top-row-div_header">Female 25-34</div>
						<div className="top-row-div_header">Female 35-44</div>
						<div className="top-row-div_header">Female 45-54</div>
						<div className="top-row-div_header">Female 55-64</div>
						<div className="top-row-div_header">Female 65+</div>
					</div>
					<div id="top_row">
						<div className="top-row-div" id='18-24-m'><img id='img_f_18_24' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_f_25_34' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_f_35_44' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_f_45_54' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_f_55_64' className='img_size'></img></div>
						<div className="top-row-div"><img id='img_f_65' className='img_size'></img></div>
					</div>
					<div id="top_row">
					    <div className="top-row-div_label" id='lbl_18_24_f'></div>
						<div className="top-row-div_label" id='lbl_25_34_f'></div>
						<div className="top-row-div_label" id='lbl_35_44_f'></div>
						<div className="top-row-div_label" id='lbl_45_54_f'></div>
						<div className="top-row-div_label" id='lbl_55_64_f'></div>
						<div className="top-row-div_label" id='lbl_65_f'></div>
					</div>
				</div>
				<div id="right_container">
					<p className="media_lib_lbl">Media Library</p>
					<div id="lib_div" className='lib_media_div'>

					</div>
				</div>
			</div>

              </div>

            </div>
          </center>
          
        </div>
        
        <div className="footer">
        <br></br>
          <p className="text3, hidden">MJM Technologies, Inc.</p>
          <p className="text3, hidden">xxx-xxx-xxxx</p>
          <p className="text3">&copy; ApolloMusicPlayer.com</p>
          <p className="text3, hidden">&copy;2020 MJM Technologies, Inc.</p>
          <p className="text3">Pat. No. 11,232,469</p>
        <br></br>
        </div>
        </div>
      </div >
    );
  }
}